import React from 'react'

import { Player } from 'video-react'

import {
    EuiText,
    EuiIcon,
    EuiPanel
  } from '@elastic/eui'

import { OutboundLink } from 'gatsby-plugin-gtag'

require('../../Layout/chrome/assets/video.css')

function VideoCard() {
  return (
    <EuiPanel paddingSize="m">
        <Player>
            <source src="https://wiki.instar.com/videos/INSTAR_Cloud_Administration_und_Uebersicht_der_möglichen_Einstellmöglichkeiten.mp4" />
        </Player>
        <EuiText>
            <p>In diesem Video zeigen wir Ihnen die Einstellmöglichkeiten in Ihrem INSTAR Cloud Benutzerkonto. Auf <OutboundLink href="https://www.youtube.com/watch?v=oPIyuBzLlQ4" target="_blank" rel="noopener noreferrer">Youtube ansehen <EuiIcon type="popout" /></OutboundLink></p>
        </EuiText>
    </EuiPanel>
  );
}

export default VideoCard